import React from 'react';
import Header from './components/main/Header';
import Footer from './components/main/Footer';
import Payment from './components/pages/Payment';
const App = () => {

    return (
        <>
            <Header/>
            <Payment/>
            <Footer/>
        </>
    );
};

export default App;
